<template>
  <div>
    <menu-item
      :item="tab"
      :key="tab.id"
      v-for="tab in tabs"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import MenuItem from '@/components/menu/MenuItem';
import MenuItemMixin from '@/mixins/MenuItemMixin';

export default {
  name: 'CommonMenu',

  mixins: [
    MenuItemMixin,
  ],

  components: {
    MenuItem,
  },

  props: {
    view: {
      type: String,
      required: false,
    },
  },

  computed: {
    ...mapGetters('subscription', {
      saasSubscription: 'GET_SAAS_SUBSCRIPTION',
    }),
    ...mapGetters('user', {
      pendingDataRequest: 'GET_HAS_PENDING_DATA_REQUESTS',
      readOnly: 'GET_READONLY_INFO',
    }),

    canShowSaasItems() {
      return this.hasSaasSubscription
          && this.readOnly?.ownerSaasId
          || this.readOnly?.saasRole
          && this.readOnly?.saasRole !== 'user';
    },

    hasSaasSubscription() {
      return !!this.saasSubscription;
    },

    isOldUser() {
      return this.readOnly?.isOldUser;
    },

    isSaas() {
      return !!this.readOnly?.saasId;
    },

    isSaasTeam() {
      return this.isSaas && this.readOnly?.saasRole !== 'user';
    },

    pendingDoctorConfigs() {
      let total = 0;

      if (this.pendingDataRequest) {
        total += 1;
      }

      return total;
    },

    tabs() {
      const hasPendingDataRequests = this.pendingDataRequest;
      const isDoctor = this.view === 'doctor';
      const showFinance = isDoctor || this.isOldUser || this.canShowSaasItems;
      const tabs = [];

      tabs.push(
        {
          active: this.isActive('support'),
          icon: 'mdi-lifebuoy',
          color: 'green',
          title: this.$t('menu.support'),
          to: 'support',
        },
        showFinance
          ? {
              color: 'green',
              icon: 'mdi-finance',
              title: this.$t('menu.finance'),
              to: isDoctor && !this.isSaasTeam
                ? 'doctor-finance'
                : 'owner-finance-overview',
              active: isDoctor && !this.isSaasTeam
                ? this.isActive('doctor-finance')
                : this.isActive('owner-finance'),
            }
          : null,
        this.isSaas
          ? null
          : {
              color: 'blue',
              icon: 'mdi-rss',
              href: 'https://blog.habitatconsultorios.com.br/',
              target: '_blank',
              title: this.$t('menu.blog'),
            },
        {
          active: this.isActive('settings'),
          alert: hasPendingDataRequests,
          badge: () => {
            if (isDoctor) {
              return this.pendingDoctorConfigs;
            }

            return 0;
          },
          color: 'purple',
          icon: 'mdi-cog',
          title: this.$t('menu.sytemConfigs'),
          to: 'settings',
        },
      );

      return tabs
        .filter(Boolean);
    },
  },
}
</script>
